module.exports = __webpack_public_path__ + "img/partners14.b16d7ef1.jpg";